import { Content } from '@wajeez-web/core/api-base';
import React from 'react';
import {
  useContentDispatch,
  useContentSelector,
  ContentEntityActions,
} from '@wajeez-web/stores/content';
import { isMobile } from '@wajeez-web/components/helpers';
import { useNavigate } from 'react-router';
import { useCommonSelector } from '@wajeez-web/stores/common';
export interface ClickableComponentLayoutProps {
  content?: Content.ContentEntityOutput | undefined | null;
  widthStyle?: string;
  customStyle?: string;
  contentEntityId?: string;
  contentEntityType?: string;
  onClick?: () => void;
  onClickExtra?: () => void;
}

export function ClickableComponentLayout({
  content,
  widthStyle = 'w-full',
  customStyle,
  contentEntityId,
  contentEntityType,
  onClick,
  onClickExtra,
  children,
}: React.PropsWithChildren<ClickableComponentLayoutProps>) {
  const navigate = useNavigate();
  const dispatch = useContentDispatch();
  const { contentWithAudioState } = useContentSelector((s) => s.contentEntity);

  const isSliderMoving = useCommonSelector(
    ({ common }) => common.isSliderMoving
  );

  const action = () => {
    console.log(content)
    const pageContentTypes = [
      'CATEGORY',
      'SUBCATEGORY',
      'CURATEDLIST',
      'PODCASTHUB',
    ];
    if (
      pageContentTypes.includes(
        (content?.contentEntityType as string) || (contentEntityType as string)
      )
    ) {
      navigate(
        `/content/${content?.contentEntityType || contentEntityType}/${
          content?.id || contentEntityId
        }`
      );
    } else {
      dispatch(ContentEntityActions.setSelectedListeningChapter(null));
      if (isMobile()) {
        dispatch(
          ContentEntityActions.setContentWithAudioState({
            id: content?.id || contentEntityId,
            type: content?.contentEntityType || contentEntityType,
            playerView: Content.PlayingMode.ListiningPage,
            mode: Content.PlayingMode.ListiningPage,
            play: true,
          })
        );
      } else {
        dispatch(
          ContentEntityActions.setContentWithAudioState({
            id: content?.id || contentEntityId,
            type: content?.contentEntityType || contentEntityType,
            playerView: Content.PlayingMode.ListiningPage,
            mode: Content.PlayingMode.ListiningPage,
            openWebPlayer: false,
            play: true,
          })
        );
        console.log(`/content/${content?.contentEntityType || contentEntityType}/${
            content?.id || contentEntityId
          }`)
        navigate(
          `/content/${content?.contentEntityType || contentEntityType}/${
            content?.id || contentEntityId
          }`
        );
      }
    }
  };

  return (
    <div
      onClick={() => {
        if (!isSliderMoving) {
          if (onClick) {
            onClick();
          } else {
            action();

            onClickExtra && onClickExtra();
          }
        }
      }}
      className={`${widthStyle} ${customStyle} cursor-pointer`}
    >
      {children}
    </div>
  );
}
